<template>
  <div class="storeStatics">
    <div style="width: 100%;height:50px;">
      <el-form ref="form" label-position="right">
        <el-row :gutter="5">
          <el-col :span="40">
            <el-form-item><el-date-picker v-model="time" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"> </el-date-picker></el-form-item>
          </el-col>
          <el-col :span="40">
            <el-form-item>
              <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getStatics">搜索</el-button>
              <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      
    </el-form>
    </div>
    <div id="statics"></div>
    <div class="storeAndDevice" id="inline"></div>
    <div class="rankTable">
      <el-table :data="rankData" style="margin:auto;width:calc(100% - 200px)" height="400" border :row-style="{ height: '0.2%' }" :cell-style="{ padding: '0.2%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}">
        <el-table-column label="门店编号" prop="storeCode"></el-table-column>
        <el-table-column label="门店名称" prop="storeName"></el-table-column>
        <el-table-column label="门店总收益(元)" prop="storeProfit"></el-table-column>
        <el-table-column label="门店总订单数" prop="storeOrderCount"></el-table-column>
        <el-table-column label="日单产(元)" prop="dayCount"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import { getStoreStatics, getStoreRank, getAreaStoreAndDevice, } from "../../api/storemanagement/storeStatics.js";
export default {
  name: "StoreStatics",
  data() {
    return {
      time: "",
      tableData: "",
      option: [],
      rankData: [],
      storeAndDevice: [],
    };
  },
  methods: {
    getStatics() {
      this.option = [];
      let params = {
        startTime: this.time[0],
        endTime: this.time[1],
      };
      let x = [];
      let y = [];
      getStoreStatics(params).then((result) => {
        for (var i = 0; i < result.data.length; i++) {
          x.push(result.data[i].date);
          y.push(result.data[i].newAddStoreSum);
        }
        this.option.push(x);
        this.option.push(y);
        this.initCharts();
      });
    },
    initCharts() {
      let myChart = echarts.init(document.getElementById("statics"));
      myChart.setOption({
        color: ["#FF9000"],
        title: {
          text: "近六个月新增门店统计",
          textStyle: {
            color: "#FF9000",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.option[0],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "增长数量",
            type: "bar",
            barWidth: "50%",
            data: this.option[1],
          },
        ],
      });
    },
    getStoreAndDeviceInfo() {
      let x = [];
      let y = [];
      let z = [];
      getAreaStoreAndDevice().then((result) => {
        for (var i = 0; i < result.data.length; i++) {
          x.push(result.data[i].area);
          y.push(result.data[i].storeCount);
          z.push(result.data[i].deviceCount);
        }
        this.storeAndDevice.push(x);
        this.storeAndDevice.push(y);
        this.storeAndDevice.push(z);
        this.getStoreAndDevice();
      });
    },
    getStoreAndDevice() {
      let myChart = echarts.init(document.getElementById("inline"));
      myChart.setOption({
        color: ["#0DC36C"],
        title: {
          text: "各地区门店以及设备数量",
          textStyle: {
            color: "#F6AD36",
          },
        },
        legend: {
          data: ["门店", "设备"]
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.storeAndDevice[0],
        },
        toolbox: {
        feature: {
            saveAsImage: {}
        }
    },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "门店",
            data: this.storeAndDevice[1],
            type: "line",
            stack: "总量",
            itemStyle: {
              normal: {
                color: "#58FA58", //改变折线点的颜色
                lineStyle: {
                  color: "#58FA58", //改变折线颜色
                },
              },
            },
          },
          {
            name: "设备",
            data: this.storeAndDevice[2],
            type: "line",
            stack: "总量",
            itemStyle: {
              normal: {
                color: "black", //改变折线点的颜色
                lineStyle: {
                  color: "#ff9000", //改变折线颜色
                },
              },
            },
          },
        ],
      });
    },
    reset() {
      this.time = "";
    },
  },
  mounted() {
    this.getStatics();
    this.initCharts();
    getStoreRank().then((result) => {
      this.rankData = result.data;
    });
    this.getStoreAndDeviceInfo();
  },
};
</script>

<style scoped>
.storeStatics {
  width: 100%;
  height: 100%;
}
#statics {
  border: 1px solid #ff9000;
  width: 42%;
  height: 30%;
  margin: 3% 6%;
  float: left;
}
#inline {
  border: 1px solid #ff9000;
  width: 40%;
  height: 30%;
  margin-top: 3%;
  float: left;
}
.el-form {
  float: left;
  width: 100%;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/storemanagement/storestatics.vue